export default __webpack_public_path__ + "static/media/iAudios.bfd01684.png";